export const T_KEY = "all";
export const TC_KEY = "allc";
export const TD_KEY = "direction";
export const TP3_KEY = "purchase3";
